import React, { useEffect, useRef } from 'react';
import book1 from './book1.jpg';
import book2 from './book2.jpg';
import buttonArrow from './assets/images/button-arw.svg';
import './App.css';

function valueAtPercentage({ from, to, percentage }) {
  return from + (to - from) * percentage;
}

function observeElement(target, { offsetTop = 0, offsetBottom = 0 }, onScroll) {
  function handleScroll() {
    const rect = target.getBoundingClientRect();
    const visibleHeight = window.innerHeight - offsetTop - offsetBottom;
    const percentageY = Math.min(
      Math.max((visibleHeight - rect.top) / visibleHeight, 0),
      1
    );
    onScroll({ percentageY });
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);

  handleScroll();

  return () => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', handleScroll);
  };
}

const books = [
  {
    title: 'Tree Wise: The Signing Branches',
    author: 'Antoinette Abbamonte',
    description:
      'A children’s book introducing hearing students to Deaf culture through the eyes of a wise, signing tree.',
    image: book1,
    link: ' https://www.amazon.com/Tree-Wise-Branches-Antoinette-Abbamonte/dp/1628576464/ref=sr_1_1?crid=1P5GL2MF0KW1Z&dib=eyJ2IjoiMSJ9.fKhEGPFwb2Bin9L-tOKleF40H-95oI3oS5gPcuZmmVY.02yAF-BFOHrUei5fjx1qzmjrnmy3H-yigSTZ58vkh0I&dib_tag=se&keywords=antoinette+abbamonte&qid=1750352016&s=books&sprefix=antoinette+abbamonte%2Cstripbooks%2C75&sr=1-1',
  },
  {
    title: 'Gratitude, Trust, Intimacy And Love',
    author: '',
    praise: 'Praise: "A beautiful tool for classrooms and families alike"',
    description:
      'A memoir of identity, resilience, and transformation within the Deaf community.',
    image: book2,
    link: 'https://www.amazon.com/Gratitude-Trust-Intimacy-Expressive-Language/dp/1681819724/ref=sr_1_2?crid=1P5GL2MF0KW1Z&dib=eyJ2IjoiMSJ9.fKhEGPFwb2Bin9L-tOKleF40H-95oI3oS5gPcuZmmVY.02yAF-BFOHrUei5fjx1qzmjrnmy3H-yigSTZ58vkh0I&dib_tag=se&keywords=antoinette+abbamonte&qid=1750352016&s=books&sprefix=antoinette+abbamonte%2Cstripbooks%2C75&sr=1-2',
  },
];

export const BookSection = () => {
  // const initialTop = 80;
  // const stepOffset = 0;
  // const cardRefs = useRef([]);

  // useEffect(() => {
  //   const cleanupFns = [];

  //   const cards = cardRefs.current;
  //   cards.forEach((card, index) => {
  //     const offsetTop = initialTop + index * stepOffset;
  //     const cardInner = card.querySelector('.card__inner');
  //     const nextCard = cards[index + 1];

  //     if (!nextCard || !cardInner) return;

  //     const toScale = 1 - (cards.length - 1 - index) * 0.1;

  //     const cleanup = observeElement(
  //       nextCard,
  //       {
  //         offsetTop,
  //         offsetBottom: window.innerHeight - card.clientHeight,
  //       },
  //       ({ percentageY }) => {
  //         // cardInner.style.scale = valueAtPercentage({
  //         //   from: 1,
  //         //   to: toScale,
  //         //   percentage: percentageY,
  //         // });
  //         // cardInner.style.filter = `brightness(${valueAtPercentage({
  //         //   from: 1,
  //         //   to: 0.6,
  //         //   percentage: percentageY,
  //         // })})`;
  //       }
  //     );

  //     cleanupFns.push(cleanup);
  //   });

  //   return () => {
  //     cleanupFns.forEach((fn) => fn());
  //   };
  // }, []);

  return (
    <section
      id="books"
      className="bg-[#2C4728] pt-8 pb-8 sm:pb-0 sm:py-16 px-5 sm:px-6 md:px-12 text-white font-serif relative z-10"
    >
      <div className="relative z-10 max-w-[1260px] mx-auto space-y-14">
        <h2 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel lg:mb-14 mb-8">
          Books
        </h2>

        <div className="relative" id="cards">
          {books.map((book, index) => {
            return (
              <div
                key={index}
                id={`card-${index + 1}`}
                className="sm:sticky top-[80px] z-[1] card"
              >
                <div className=" flex items-center z-[2] ">
                  <div className="card__inner bg-[#DEDEDE] rounded-[48px] p-6 lg:py-[18px] lg:ps-[28px] lg:pe-[130px] flex flex-col md:flex-row items-center gap-[40px] xl:gap-[125px] text-black shadow-md w-full transition-transform duration-300">
                    <div className="w-full sm:w-[240px] lg:w-[340px] xl:w-[490px] sm:h-full lg:h-[340px] xl:h-[410px] sm:h-[412px]">
                      <img
                        src={book.image}
                        alt={book.title}
                        className="w-full h-full rounded-[33px] shadow-md object-cover"
                      />
                    </div>

                    <div className="flex-1 lg:w-2/3 w-full flex flex-wrap sm:mt-[30px] lg:mt-0">
                      {book.author && (
                        <p className="text-[16px] text-[#999999] mb-5 w-full font-ubuntu font-medium">
                          By {book.author}
                        </p>
                      )}
                      {book.praise && (
                        <p className="text-[16px] text-[#999999] mb-5 w-full font-ubuntu font-medium">
                          {book.praise}
                        </p>
                      )}
                      <h3 className="text-[36px] leading-[118%] text-black mb-5 font-cinzel">
                        {book.title}
                      </h3>
                      <p className="mb-6 text-base leading-[23px] font-bold font-ubuntu">
                        {book.description}
                      </p>
                      <a
                        href={book.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex justify-end items-center font-cinzel bg-[#2C4728] text-[18px] gap-5 text-white p-1 ps-[20px] rounded-full hover:bg-[rgba(0,0,0,0.2)] text-[14px] min-w-[200px] uppercase transition-all duration-400 ease-custom"
                      >
                        Buy on Amazon
                        <i className="h-[40px] w-[40px] rounded-full text-[#fff] bg-[#F2BA35] group-hover:rotate-[42deg] transition-all duration-400 ease-custom flex items-center justify-center">
                          <img src={buttonArrow} alt="Buy on Amazon" />
                        </i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default BookSection;
